document.addEventListener("alpine:init", () => {
    Alpine.data("progressiveAccordion", (autoplay) => ({
        active: null,
        tick: null,
        timeout: null,
        duration: autoplay ? autoplay * 1000 : null,
        autoAdvance: autoplay ? true : false,
        items: null,
        i: 0,
        init() {},
        advanceItems() {
            this.i = 0;
            this.items = this.$el.querySelectorAll(
                ".Progressive__Accordion__Item"
            );
            this.active = this.items[this.i].id;
            this.timeout;
            clearTimeout(this.timeout);

            this.advance = () => {
                if (this.autoAdvance) {
                    if (this.i < this.items.length) {
                        this.active = this.items[this.i].id;
                        this.items[this.i].querySelector(
                            ".Progressive__Accordion__progress"
                        ).style.transitionDuration = this.duration + "ms";
                        this.$dispatch("pegasus-pa-item-selected", {
                            id: this.items[this.i].id,
                        });
                        clearTimeout(this.tick);
                        this.i++;
                        this.timeout = setTimeout(this.advance, this.duration);
                    } else {
                        clearTimeout(this.timeout);
                        this.i = 0;
                        this.advance();
                    }
                }
            };
            this.advance();
        },
        changeItem(item) {
            this.active = item;
            this.$dispatch("pegasus-pa-item-selected", { id: item });
            this.autoAdvance = false;
        },
    }));
});
